<breadcrumb [items]="breadcrumb" />
<div class="d-flex align-items-center justify-content-between mb-2">
    <h1 class="mb-0">Consultas</h1>
    <button class="btn btn-primary" (click)="openModal(uploadFooter)">Upload Vídeo</button>
</div>
@if (activeConsultation$ | async; as activeConsultation) {
    <div class="card border-success bg-success-subtle shadow-sm mb-3">
        <div class="card-body d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
            <div>
                <div class="d-flex align-items-center gap-2 mb-2">
                    <span class="badge text-bg-success">Ao vivo</span>
                    <strong>Consulta em andamento</strong>
                </div>
                <div class="row g-3">
                    <div class="col-12 col-md-auto">
                        <label class="text-success-emphasis">Paciente</label>
                        <div>{{ getActivePatientName(activeConsultation) }}</div>
                    </div>
                    <div class="col-6 col-md-auto">
                        <label class="text-success-emphasis">Sexo</label>
                        <div>{{ getActivePatientSex(activeConsultation) }}</div>
                    </div>
                    <div class="col-12 col-md-auto">
                        <label class="text-success-emphasis">Status</label>
                        <div>Em andamento</div>
                    </div>
                </div>
            </div>
            <button type="button" class="btn btn-success align-self-start align-self-lg-center" (click)="openActiveConsultation(activeConsultation)">
                <i class="bi bi-box-arrow-up-right me-1"></i>
                Abrir consulta
            </button>
        </div>
    </div>
}
<div class="card card-body border-0 bg-body-tertiary shadow-sm pt-2 mb-3">
    <form class="row gx-3 align-items-end" novalidate (ngSubmit)="getAll()">
        <div class="col-12 col-md">
            <label for="startDate">Inicio</label>
            <input id="startDate" name="startDate" type="date" class="form-control" [(ngModel)]="filters.startDate" />
        </div>
        <div class="col-12 col-md">
            <label for="endDate">Fim</label>
            <input id="endDate" name="endDate" type="date" class="form-control" [(ngModel)]="filters.endDate" />
        </div>
        <div class="col-12 col-md">
            <label for="cid">CID</label>
            <input id="cid" name="cid" type="text" class="form-control" placeholder="Ex.: J45" [(ngModel)]="filters.cid" />
        </div>
        <div class="col-12 col-md">
            <label for="cidDescricao">Descrição do CID</label>
            <input id="cidDescricao" name="cidDescricao" type="text" class="form-control" placeholder="Ex.: Tontura" [(ngModel)]="filters.cidDescricao" />
        </div>
        <div class="col-12 col-md" accessControl="ARIEL_ADMIN">
            <label for="doctors">Médico</label>
            <ng-select name="user" [items]="doctor$ | async" bindValue="id" [loading]="loading.doctors" typeToSearchText="Buscar médico..." [typeahead]="doctorInput$" [(ngModel)]="filters.doctorId">
                <ng-template ng-label-tmp ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    {{ item.name }}
                    <small class="text-body-tertiary ms-1">{{ item.crm ? "CRM: " + item.crm : "" }}</small>
                </ng-template>
            </ng-select>
        </div>
        <div class="col-12 col-md-auto">
            <button type="submit" class="btn btn-primary w-100" [disabled]="loading.main">
                <div class="spinner-border spinner-border-sm" role="statusEncerramento" *ngIf="loading.main"></div>
                <i class="bi bi-search" *ngIf="!loading.main"></i>
            </button>
        </div>
    </form>
</div>
<div class="table-responsive">
    <ng-generate-table tableClass="table table-hover" [loading]="loading.main" [columns]="columns" [data]="consultations" />
</div>
<div class="my-3" *ngIf="!loading.main && pagination.total">
    <pagination [total]="pagination.total" [page]="pagination.page" [pageSize]="pagination.pageSize" (change)="getAll($event)" (first)="getAll($event)" (last)="getAll($event)"></pagination>
</div>

<ng-template #uploadBody>
    <div class="container-fluid">
        <div class="row mb-3">
            <input type="file" id="videoUpload" class="form-control" accept="video/*" (change)="onVideoSelected($event)" [disabled]="loading.modal" />
        </div>
    </div>
</ng-template>

<ng-template #uploadFooter>
    <div class="container-fluid">
        <div class="row row-cols-4 justify-content-end">
            <button type="button" class="btn btn-light me-2" (click)="closeModal()">Cancelar</button>
            <button type="button" class="btn btn-primary" [disabled]="loading.modalUpload" (click)="submitUploadVideo()">
                <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading.modalUpload"></div>
                <span *ngIf="!loading.modalUpload">Enviar</span>
            </button>
        </div>
    </div>
</ng-template>
